// usePrepStationSelection.ts
import { useEffect, useState } from 'react';
import { store } from '@app/state/store';

import {
  applyKitchenTicketChangesToPrepStations,
  CoreRootState,
  IKitchenTicketDiffObject,
  IKitchenTicketSettings,
  IPrepStationToSelect,
} from '@westondev/tableturn-core';

export function usePrepStationSelection(
  initialDiff: IKitchenTicketDiffObject,
  setSettingsDiffObject: (diff: IKitchenTicketDiffObject) => void,
  initialChangeData: IKitchenTicketSettings,
) {
  const [diffObject, setDiffObject] = useState(initialDiff);
  const [changeData, setChangeData] = useState(initialChangeData);

  const [versionIndex, setVersionIndex] = useState(0);
  const [modalOpen, setModalOpen] = useState(false);

  useEffect(() => {
    setDiffObject(initialDiff);
  }, [initialDiff]);

  useEffect(() => {
    setChangeData(initialChangeData);
  }, [initialChangeData]);

  const handleApplyChanges = (prepStations: IPrepStationToSelect[]) => {
    const applyObject = {
      currentPrepStation: versionIndex,
      prepStationsToApplyChanges: prepStations,
    };

    const { prepStationVersions, changeData: newData } =
      applyKitchenTicketChangesToPrepStations(
        diffObject.prepStationVersions,
        applyObject,
        store.getState() as CoreRootState,
      );
    if (!prepStationVersions) return;

    const newDiff: IKitchenTicketDiffObject = {
      ...diffObject,
      prepStationVersions,
    };
    setDiffObject(newDiff);
    setSettingsDiffObject(newDiff);

    setChangeData(newData);
  };

  return {
    diffObject,
    changeData,
    versionIndex,
    setVersionIndex,
    modalOpen,
    openModal: () => setModalOpen(true),
    closeModal: () => setModalOpen(false),
    handleApplyChanges,
  };
}
